export enum StudentTypes {
  candidate,
  learner,
  intern,
}
